import deepMerge from './deepMerge.js'
import { get } from './idb.js';

async function StrArr2Obj(pending) {
    let obj = {};
    for (let [path, val] of Object.entries(pending || (await get('Pending')) || {})) {
        let str = path.replaceAll('/', '":{"').substring(2) + '":'
        str += JSON.stringify(val);
        str += Array((path.match(/\//g) || []).length).fill('}').join('');
        str=str.replaceAll(':undefined',':""');
        let o = JSON.parse(str);
        obj = deepMerge(obj, o);
    }
    return obj;
}

export default StrArr2Obj;
